


















import { Vue, Component, Prop } from "vue-property-decorator";
import { Calendar, Popup, Overlay } from "vant";
@Component({
  name: "headerBar",
  components: {},
})
export default class extends Vue {
  @Prop()
  navStyle?: string;

  @Prop()
  leftStyle?: string;

  @Prop()
  centerStyle?: string;

  @Prop()
  rightStyle?: string;

  @Prop()
  replaceEvent?: boolean;

  back() {
    if (this.replaceEvent) {
      this.$emit("back");
      return;
    }
    history.back();
  }
}
